export default function () {
  return window?.uetq?.msClkId as string | undefined
}
